import { jsx as _jsx } from "react/jsx-runtime";
import cx from 'clsx';
import styles from './spinnerStyles.module.scss';
import { SmallSpinner, LargeSpinner } from './SpinnerSVGs';
/**
 * @title
 *  Spinner
 * @label
 *  Spinner
 * @shortdescription
 *  Spinner
 * @keywords
 *  [spinner]
 * @description
 *  A circle loading spinner
 * @componentUsage
 *  <Spinner/>
 *
 *  <Spinner
 *    spinnerSize={string} small or large, small by default
 *    ariaLabel={string} 'loading' by default
 *    spinnerVariant={string} only supported variants, green by default
 *  />
 * @example
 *  <Spinner />
 *
 *  <Spinner
 *    spinnerSize='large'
 *    ariaLabel='loading'
 *    spinnerVariant={'redSpinner'}
 *  />
 */
export const Spinner = ({ className, ariaLabel = 'loading', spinnerSize = 'small', spinnerVariant = 'greenSpinner', }) => {
    const SpinnerElement = spinnerSize === 'small' ? SmallSpinner : LargeSpinner;
    return (_jsx(SpinnerElement, { className: cx(className, styles.spinAnimation, styles[spinnerVariant]), role: "status", "aria-label": ariaLabel }));
};
//# sourceMappingURL=Spinner.js.map